import InsightViewOption from 'enums/InsightViewOption'

export const CALCULATED_OPTIONS = [
  InsightViewOption.NET_SENTIMENT,
  InsightViewOption.PASSION_INTENSITY,
  InsightViewOption.ENGAGEMENT_RATIO_ONLY,
  InsightViewOption.STAR_RATINGS,
  InsightViewOption.SURVEY_SCORES
]

export const SUPPORT_WEIGHING_OPTIONS = [
  InsightViewOption.NET_SENTIMENT,
  InsightViewOption.PASSION_INTENSITY,
  InsightViewOption.STAR_RATINGS,
  InsightViewOption.SURVEY_SCORES
]

export const DUMMY_COLUMN_ID = '-1'

export const ROW_GRAND_TOTAL_ID = '-2'

export const MAX_CELLS = 60

export const DEFAULT_WEIGHTING = 100
